@if (!isStepPrerequisiteCompleted()) {
  <app-previous-step-incomplete-notice></app-previous-step-incomplete-notice>
} @else {
  <div class="flex flex-col gap-4">
    @if (evaluationData() && !hasParticipatingTools()) {
      <div class="card" data-testid="step-9-5-no-providers">
        <div class="text-center py-12">
          <i class="pi pi-users text-4xl text-gray-400 mb-4"></i>
          <h3 class="text-lg font-semibold text-gray-600 mb-2">
            {{ 'project.steps.rfd.evaluation.noProviders.title' | transloco }}
          </h3>
          <p class="text-gray-500 max-w-md mx-auto">
            {{ 'project.steps.rfd.evaluation.noProviders.description' | transloco }}
          </p>
        </div>
      </div>
    }

    @if (hasParticipatingTools() && evaluationData()) {
      <div class="flex flex-col gap-4">
        <!-- Header with Contributor Selection -->
        <div
          class="flex justify-between items-center bg-second-level p-4 rounded-lg border border-second-level"
        >
          <div class="font-semibold text-lg text-primary">
            {{ 'project.steps.rfd.evaluation.title' | transloco }}
          </div>
          <div class="flex gap-3 items-center">
            <div class="w-64">
              <app-evaluation-contributor-filter-dropdown
                [projectId]="projectId"
                [compact]="true"
                (contributorSelected)="onContributorSelected($event)"
              >
              </app-evaluation-contributor-filter-dropdown>
            </div>
            <!-- PMs: show direct "Add contributor" button on wider screens -->
            @if (canInviteContributors()) {
              <div class="hidden md:block">
                <p-button
                  icon="pi pi-user-plus"
                  [label]="'dotMenu.addContributor' | transloco"
                  severity="secondary"
                  styleClass="p-button level-third"
                  (onClick)="openAddContributor()"
                  data-testid="step-9-5-add-contributor-button"
                ></p-button>
              </div>
            }

            <!-- Small screens: keep the 3-dot menu fallback -->
            <div class="md:hidden">
              <app-step-dot-menu
                [projectId]="projectId"
                [preselectedRole]="contributorRole"
                [preselectedAccessiblePages]="[accessibleStep]"
              >
              </app-step-dot-menu>
            </div>
          </div>
        </div>

        <!-- Evaluation Cards per Provider -->
        <div class="flex flex-col gap-4">
          @for (tool of evaluationData()!.tools; track tool) {
            <div>
              <app-provider-evaluation-card
                [tool]="tool"
                [data]="evaluationData()!"
                [selectedUserId]="selectedContributorId()"
                [averageMode]="isAverageSelected()"
                [averageUserIds]="averageContributorUserIds()"
                [currentUserId]="projectUserDetail()?.userId"
                [readOnly]="isCurrentStepLocked() || !isCurrentUserSelected()"
                [hrToolsMap]="hrToolsMap()"
                [isExponentialScale]="isExponentialScale()"
                (saveEvaluations)="onSaveEvaluations($event)"
                (commentOpen)="onCommentOpen($event)"
              >
              </app-provider-evaluation-card>
            </div>
          }
        </div>

        <!-- Legend -->
        <app-evaluation-legend></app-evaluation-legend>

        <!-- Summary -->
        <app-evaluation-summary
          [data]="evaluationData()!"
          [hrToolsMap]="hrToolsMap()"
          [averageUserIds]="averageContributorUserIds()"
          [isExponentialScale]="isExponentialScale()"
        ></app-evaluation-summary>

        <!-- Complete Phase Button (only for PM) -->
        @if (canCompletePhase() && !isCurrentStepLocked()) {
          <div class="flex justify-end">
            <p-button
              [label]="'project.finish.phase.label' | transloco"
              (onClick)="completePhase()"
            >
            </p-button>
          </div>
        }
      </div>
    }

    <app-comment-modal
      [(visible)]="commentModalVisible"
      [comments]="currentComments"
      [currentUserId]="projectUserDetail()?.userId"
      [readOnly]="isCurrentStepLocked() || !isCurrentUserSelected()"
      (save)="onSaveComment($event)"
    >
    </app-comment-modal>
  </div>
}
